<template>
  <div id="">
    <div style="margin-bottom: 10px;">
      <el-button type="primary" @click="handleCreate">新增</el-button>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      row-key="id"
      border>
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="title" label="标题" width="200"></el-table-column>
      <el-table-column prop="taskType" label="任务类型" width="150" :formatter="taskTypeFormatter"></el-table-column>
      <el-table-column prop="runType" label="运行类型" width="150" :formatter="runTypeFormatter"></el-table-column>
      <el-table-column prop="hour" label="小时" width="100"></el-table-column>
      <el-table-column prop="minute" label="分钟" width="100"></el-table-column>
      <el-table-column label="条件" width="200">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top" width="400">
            <pre>{{ formattedJson(scope.row.conditionJson) }}</pre>
            <div slot="reference" class="name-wrapper">
              <span>{{ scope.row.conditionJson ? scope.row.conditionJson.substring(0, 20) + '...' : '' }}</span>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="是否启用" align="center" min-width="100">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.enable" @change="updateStatus(scope.row.id, scope.row.enable)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="150">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleEdit(scope.row)">修改</el-button>
          <el-button type="info" size="mini" @click="handleCopy(scope.row)">复制</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog :title="isEdit ? '编辑任务' : '新增任务'" :visible.sync="dialogVisible">
      <el-form :model="form">
        <el-form-item label="标题">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="任务类型">
          <el-select v-model="form.taskType" placeholder="请选择">
            <el-option v-for="item in taskTypes" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运行类型">
          <el-radio-group v-model="form.runType">
            <el-radio :label="1">指定时间</el-radio>
            <el-radio :label="2">每天一次</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="小时">
          <el-input-number v-model="form.hour" :min="0" :max="23"></el-input-number>
        </el-form-item>
        <el-form-item label="分钟">
          <el-input-number v-model="form.minute" :min="0" :max="59"></el-input-number>
        </el-form-item>
        <el-form-item label="运行参数">
          <el-input type="textarea" v-model="form.conditionJson"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {scheduleApi} from '../../api/index';
import {HttpResp} from '../../constant/index';

export default {
  name: 'ScheduleTaskList',
  data() {
    return {
      dialogVisible: false,
      isEdit: false,
      form: {},
      tableData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      page: 1,
      size: 10,
      total: 0,
      taskTypes: []
    }
  },
  mounted: function () {
    this.loadData();
    this.loadTaskTypes();
  },
  computed: {

  },
  methods: {
    loadTaskTypes() {
      scheduleApi.listTaskType().then(data => {
        if (data.code == HttpResp.SUCCUSS) {
          this.taskTypes = data.data;
        }
      });
    },
    runTypeFormatter(row, column, cellValue) {
      if (cellValue === 1) {
        return "指定时间";
      } else if (cellValue === 2) {
        return "每天一次";
      }
      return "未知";
    },
    taskTypeFormatter(row, column, cellValue) {
      let taskType = this.taskTypes.find(item => item.code === cellValue);
      return taskType ? taskType.name : "未知";
    },
    loadData() {
      let param = {
        pageNumber: this.page,
        pageSize: this.size
      };
      scheduleApi.pageTask(param).then(data => {
        if (data.code == HttpResp.SUCCUSS) {
          this.tableData = data.data.dataList;
          this.total = data.data.total;
        } else {
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.loadData();
    },
    updateStatus(id, enable) {
      let param = {
        enable: enable
      };
      scheduleApi.updateStatus(id, param).then(data => {
        if(data.code == HttpResp.SUCCUSS){
          this.$message({
            type: 'success',
            message: "修改成功"
          });
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    submitForm() {
      if (this.isEdit) {
        scheduleApi.updateTask(this.form).then(data => {
          if (data.code == HttpResp.SUCCUSS) {
            this.$message({
              type: 'success',
              message: "修改成功"
            });
            this.dialogVisible = false;
            this.loadData();
          } else {
            this.$message({
              type: 'error',
              message: data.message
            });
          }
        });
      } else {
        scheduleApi.saveTask(this.form).then(data => {
          if (data.code == HttpResp.SUCCUSS) {
            this.$message({
              type: 'success',
              message: "新增成功"
            });
            this.dialogVisible = false;
            this.loadData();
          } else {
            this.$message({
              type: 'error',
              message: data.message
            });
          }
        });
      }
    },
    handleCreate() {
      this.form = {};
      this.isEdit = false;
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.form = Object.assign({}, row);
      this.isEdit = true;
      this.dialogVisible = true;
    },
    handleCopy(row) {
      this.form = Object.assign({}, row);
      this.form.id = null;
      this.isEdit = false;
      this.dialogVisible = true;
    },
    formattedJson(jsonStr) {
      if (!jsonStr) {
        return '';
      }
      try {
        const obj = JSON.parse(jsonStr);
        return JSON.stringify(obj, null, 2);
      } catch (e) {
        return jsonStr;
      }
    }
  }

}
</script>
<style>
  .el-form-item__content {
    width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/schedule/ScheduleTaskList.vue